import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

const Industryusa = () => {
  return (
    <div className="Industry_usa tekrevol_dark_bg  p-100 ">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
                        <h2><span>Unlocking</span> Our Development Knowledge Across Diverse Sectors</h2>
                        <p>With a robust portfolio of successfully finished ventures, TekRevol demonstrates skill and knowledge in React Native app development, showcasing our versatility across different industries. From state-of-the-art contributions to the media and entertainment industry to impactful strides in healthcare and game development, our knowledge effortlessly grows into the world, such as medicine, logistics, banking, sports, the public sector, and beyond.</p>
                        <p>Devoted to unbending innovation, we constantly provide custom-made, groundbreaking solutions that exceed industry limits, positioning our clients at the front of technological distinction.</p>
                        <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact">Let’s Build Your React Native App</Link>
                    </Col>
                    <Col xs={12} md={4} lg={4} xl={4} xxl={4} className="offset-lg-3 offset-md-3  my-auto">
                        <div className="industry_scroll">
                            <h3>Fintech</h3>
                            <h3>Healthcare</h3>
                            <h3>E-commerce</h3>
                            <h3>Real Estate</h3>
                            <h3>Automotive</h3>
                            <h3>On-Demand</h3>
                            <h3>Education</h3>
                            <h3>Music</h3>
                            <h3>IT Staff Augmentation</h3>
                            <h3>Logistics</h3>
                            <h3>Retail</h3> 
                        </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Industryusa